/*=====================================
    Home View

    Author: Gray
    createtime: 2017 / 12 / 25
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { GlobalStyle, /* Colors */ } from 'stylecomponents';
import styled from 'styled-components';
import HomeSidebarView from 'components/home/HomeSidebarView';
import CupoyRouter from "components/commons/router/CupoyRouter";
import SmallBlock from './SmallBlock';
import BigBlock from './BigBlock';
import Banner from 'components/home/Banner/BannerView';

/*--------------------------
    Style Component
--------------------------*/
const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
`;
const Content = styled.div`
    flex: 1;
    width: ${GlobalStyle.ContainerMaxWidth - GlobalStyle.SidebarWidth - GlobalStyle.ViewSpace}px;
    margin-right: ${GlobalStyle.ViewSpace}px;
    min-width: 0;
`;
const NewsRow = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;

/*--------------------------
    Main Component
--------------------------*/
class HomeView extends PureComponent {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.fetchTopADList = this.fetchTopADList.bind(this);
        this.fetchIdxPageInfo = this.fetchIdxPageInfo.bind(this);

        this.state = {
            isActive: false,
        };
    }

    componentDidMount() {
        
        window.scrollTo({ top: 0 });

        const {
            isLoadedIdxPageInfo,
            isLoadedIdxPageTopads,
        } = this.props;

        if(!isLoadedIdxPageInfo) {
            this.fetchIdxPageInfo();
        }

        if(!isLoadedIdxPageTopads) {
            this.fetchTopADList();
        }
    }

    fetchIdxPageInfo() {
        this.props.idxPageActions.getIdxPageInfo();
    }

    fetchTopADList() {
        this.props.idxPageActions.getTopADList();
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const {
            topads = [],
            bulletin1s = [],
            bulletin2s = [],
            hotgames = [],
            hotcards = [],
            hotbonuscards = [],
            isLoadingIdxPageInfo,
            isLoadIdxPageInfoFailed,
        } = this.props;

        return (
            <GlobalStyle.SubContainer>
                <Container>
                    <Content>
                        {(topads.length > 0) && <Banner topADList={topads} />}
                        <NewsRow>
                            <SmallBlock
                                data={bulletin1s}
                                title="最新消息"
                                stateName={CupoyRouter.STATES.NEWS}
                                isError={isLoadIdxPageInfoFailed}
                                bclass={1}
                            />
                            <SmallBlock
                                data={bulletin2s}
                                title="最新活動"
                                stateName={CupoyRouter.STATES.NEWS}
                                isError={isLoadIdxPageInfoFailed}
                                bclass={2}
                            />
                        </NewsRow>
                        <BigBlock
                            title="熱門遊戲"
                            data={hotgames}
                            state={CupoyRouter.STATES.GAME}
                            isLoading={isLoadingIdxPageInfo}
                            isError={isLoadIdxPageInfoFailed}
                        />
                        <BigBlock
                            title="熱門產包"
                            data={hotcards}
                            state={CupoyRouter.STATES.VITEMPRODUCTS}
                            isLoading={isLoadingIdxPageInfo}
                            isError={isLoadIdxPageInfoFailed}
                        />
                        <BigBlock
                            title="熱門發財商城"
                            data={hotbonuscards}
                            state={CupoyRouter.STATES.BONUSPRODUCTS}
                            isLoading={isLoadingIdxPageInfo}
                            isError={isLoadIdxPageInfoFailed}
                        />
                    </Content>

                    <HomeSidebarView />
                    
                </Container>
            </GlobalStyle.SubContainer>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
    return {
        topads: state.idxpage.topads,
        bulletin1s: state.idxpage.bulletin1s,
        bulletin2s: state.idxpage.bulletin2s,
        hotgames: state.idxpage.hotgames,
        hotcards: state.idxpage.hotcards,
        hotbonuscards: state.idxpage.hotbonuscards,
        isLoadIdxPageInfoFailed: state.idxpage.isLoadIdxPageInfoFailed,
        isLoadingIdxPageInfo: state.idxpage.isLoadingIdxPageInfo,
        isLoadedIdxPageInfo: state.idxpage.isLoadedIdxPageInfo,
        isLoadedIdxPageTopads: state.idxpage.isLoadedIdxPageTopads,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        idxPageActions: bindActionCreators(actionCreators.idxPageActionCreators, dispatch),
    };
};

/*--------------------------
    export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(HomeView);